<script setup>
    import { TextareaField } from '@/js/components/Common'

    const props = defineProps({
        lehrFormen: {
            type: Array,
            required: true
        }
    })
</script>

<template>
    <div v-for="(lehrForm, index) in props.lehrFormen" :key="index" class="d-flex w-100 flex-nowrap mt-1">
        <textarea-field v-model="lehrForm.lehrformName" class="bg-primary-lighten-2 text-grey" readonly rows="2" />
        <textarea-field v-model="lehrForm.kontaktzeit" class="bg-primary-lighten-2 text-grey" readonly rows="2" />
        <textarea-field v-model="lehrForm.selbststudium" class="bg-primary-lighten-2 text-grey" readonly rows="2" />
        <textarea-field
            :model-value="lehrForm.gesamt ? lehrForm.gesamt + '\u00a0h' : ''"
            class="bg-primary-lighten-2 text-grey"
            readonly
            rows="2"
        />
    </div>
</template>

<script></script>

<style scoped lang="scss">
    // autoheight for textareas will render an empty scrollbar
    // this will hide it
    textarea {
        overflow-y: hidden !important;
    }
</style>
